import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import { CButton } from '@coreui/react-pro'
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from '../../components/details/asset-details/AppDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview'

// helpers
import Axios from 'src/helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const AssetDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();

  const [assetDetails, setAssetDetails] = useState('')

  const [openFilePreview, setOpenFilePreview] = useState(false)

  const handleCardHeaderButton = () => {
    navigate(`/asset/edit/${id}`)
  }

  useEffect(() => {
    fetchAssetDetails()
  }, [id]);

  const fetchAssetDetails = () => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/asset/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setAssetDetails(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      <div className='d-grid gap-2 d-md-flex justify-content-md-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/asset/list')}>
          Back
        </CButton>
      </div>
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Asset Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            assetDetails={assetDetails}
          />
        }
        lowerBodyContent={
          <AppCard 
            className='mt-4 mb-4'
            headerTitle={<h5>Attachment</h5>}
            bodyContent={
              <>
                {
                  assetDetails?.attachments?.length > 0 ? (
                    <FormFileThumbnail 
                      name='attachments'
                      colSize='4'
                      files={assetDetails?.attachments}
                      className='justify-content-start align-items-center'
                      isDetailPage={true}
                      handleViewFile={setOpenFilePreview}
                    />
                  )
                  : (
                    <>Not Found</>
                  )
                } 
              </>
            }
          />
        }
      />
    </>
  )
}

export default AssetDetails
